import builder from '../builder';
import RoadSignWarning from '../../streamline-icons/bold/road-sign-warning.svg';

export default builder('RoadSignWarningBold', RoadSignWarning);
